import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import GeneralForm from './GeneralForm'
import Joyride from 'react-joyride'
import CustomJoyride from '../CustomJoyride/CustomJoyride'
import { getIntroSteps, handleProfileAsideJoyride, introStyles } from '../CustomJoyride/joyride.helper'
import { setUiPropThunk } from '../../redux/ui/ui.action'
import UserAvatarEditor from '../AvatarEditor/UserAvatarEditor/UserAvatarEditor'
import { getUiInfo } from '../../api/getApi'
import { isMobileDevice } from '../../helpers/mobileDevice.helper'
import MobileTourSheet from '../MobileTourSheet/MobileTourSheet'
import useMediaQuery from '@mui/material/useMediaQuery'
import { confirm } from '../../UI/Confirm/Confirm'

export default function General() {
  const dispatch = useDispatch()
  const grandTotal = useSelector(({ user }) => user.profile?.filler?.grand_total)
  const { hasSurvey, popupAboutSocialMediaStatus } = useSelector(({ ui }) => ui)

  const isTabletOrMobile = useMediaQuery('(max-width: 1200px)', { noSsr: true })
  const steps = React.useMemo(() => getIntroSteps({ isMobile: isMobileDevice, grandTotal }), [grandTotal])
  const [joyride, setJoyride] = React.useState({
    run: false,
    steps,
  })
  React.useEffect(() => {
    getUiInfo().then((data) => {
      setJoyride((prev) => ({
        ...prev,
        run: !hasSurvey && hasSurvey !== null && !popupAboutSocialMediaStatus?.banner_type && !data.trial_passed,
        steps,
      }))
    })
  }, [steps, hasSurvey, popupAboutSocialMediaStatus])

  React.useEffect(() => {
    if (typeof window === 'undefined' || typeof document === 'undefined') return undefined
    if (!joyride.run) return undefined

    window.scrollTo({ top: 0, left: 0, behavior: 'auto' })

    const handleScrollToTop = () => {
      if (window.scrollY !== 0) {
        window.scrollTo({ top: 0, left: 0, behavior: 'auto' })
      }
    }

    window.addEventListener('scroll', handleScrollToTop, { passive: true })

    const { style: bodyStyle } = document.body
    const { style: htmlStyle } = document.documentElement

    bodyStyle.overflow = 'hidden'
    htmlStyle.overflow = 'hidden'

    return () => {
      window.removeEventListener('scroll', handleScrollToTop)
      bodyStyle.overflow = 'auto'
      htmlStyle.overflow = 'auto'
    }
  }, [joyride.run])

  function joyrideCallback(event) {
    handleProfileAsideJoyride(event, { isMobile: isMobileDevice, stepsLength: steps.length })

    if (event.status === 'finished') {
      setJoyride((prev) => ({
        ...prev,
        run: false,
      }))
      dispatch(setUiPropThunk({ trial_passed: true }))
    }

    if (event.status === 'skipped') {
      confirm(
        'Do not show again?',
        'Do you want to disable this tutorial next time?',
        () => {
          setJoyride((prev) => ({
            ...prev,
            run: false,
          }))
          dispatch(setUiPropThunk({ trial_passed: true }))
        },
        () => {
          setJoyride((prev) => ({
            ...prev,
            run: false,
          }))
        }
      )
    }
  }

  return (
    <>
      {isTabletOrMobile ? (
        <MobileTourSheet
          run={joyride.run}
          steps={joyride.steps}
          onEvent={(event) => {
            handleProfileAsideJoyride(event, { isMobile: isMobileDevice, stepsLength: steps.length })
          }}
          onFinish={(status) => {
            if (status === 'finished') {
              setJoyride((prev) => ({
                ...prev,
                run: false,
              }))
              dispatch(setUiPropThunk({ trial_passed: true }))
            }

            if (status === 'skipped') {
              confirm(
                'Do not show again?',
                'Do you want to disable this tutorial next time?',
                () => {
                  setJoyride((prev) => ({
                    ...prev,
                    run: false,
                  }))
                  dispatch(setUiPropThunk({ trial_passed: true }))
                },
                () => {
                  setJoyride((prev) => ({
                    ...prev,
                    run: false,
                  }))
                }
              )
            }
          }}
        />
      ) : (
        <Joyride
          callback={joyrideCallback}
          steps={joyride.steps}
          run={joyride.run}
          continuous
          disableCloseOnEsc
          disableOverlayClose
          showSkipButton
          tooltipComponent={CustomJoyride}
          styles={introStyles}
        />
      )}
      <div className='general_forms profile-content'>
        <UserAvatarEditor />
        <GeneralForm />
      </div>
    </>
  )
}
